/**
 * Recharge widget anti-flicker reveal.
 *
 * The section hides `recharge-subscription-widget` via CSS
 * (`html:not(.iw-recharge-revealed) ... { display:none }`) when the
 * "Hide Recharge widget until it renders" setting is on. This watches the
 * widget render its purchase options in its (open) shadow DOM, waits a
 * configurable delay (window.IWRechargeRevealDelay, ms), then reveals it by
 * adding `iw-recharge-revealed` to <html>.
 *
 * Tied to Recharge, NOT Intelligems — a failed/blocked IG load can't leave the
 * widget hidden. The hardcoded failsafe reveals it even if the widget never
 * renders. Loaded once per page, only when the setting is on.
 */
(function () {
  var FAILSAFE_MS = 4000; // reveal anyway if the widget never renders
  var delay = typeof window.IWRechargeRevealDelay === 'number' ? window.IWRechargeRevealDelay : 400;

  var revealed = false;
  var reveal = function () {
    if (revealed) return;
    revealed = true;
    document.documentElement.classList.add('iw-recharge-revealed');
  };

  var startedAt = Date.now();
  (function poll() {
    if (revealed) return;
    var w = document.querySelector('recharge-subscription-widget');
    var ready = w && w.shadowRoot && w.shadowRoot.querySelector('.rc-purchase-option, [part~="rc-purchase-option"]');
    if (ready) { setTimeout(reveal, delay); return; }            // rendered → wait delay → reveal
    if (Date.now() - startedAt >= FAILSAFE_MS) { reveal(); return; } // failsafe
    requestAnimationFrame(poll);
  })();
})();
